import React, { Component } from 'react'
import { Row, Col, Card, CardHeader, CardBody, Table, FormGroup, Label, Input, Button } from 'reactstrap'
import { withApollo, graphql } from 'react-apollo'
import PropTypes from 'prop-types'
import CreatableSelect from '../Wps/CreatableSelect'
import { AvForm } from 'availity-reactstrap-validation'
import { ElementsFetchQuery, ProjectDefectivenessQuery, ProjectDefectivenessDetailsQuery } from './query'
import BlockWithLoader from '../Support/BlockWithLoader'
import { countPercent, InspectionTableHeaders, InspectionTableData } from './defectivness/'
import { CreateProjectDefectivenessReportJob } from './mutations'
import { GET_JOBS } from '../JobsNotifications/graphql'
import DownloadReportModal from './DownloadReportModal'

class ProjectDefectiveness extends Component {

  constructor(props) {
    super(props)
    const params = new URLSearchParams(window.location.search)
    this.state = {
      filters: {},
      data_loading: false,
      project: null,
      element: null,
      projectElements: [],
      withoutNodes: params.get('withoutNodes') === 'true',
      dateFrom: params.get('dateFrom') || '',
      dateTo: params.get('dateTo') || '',
      dateType: params.get('dateType') || 'welding',
      executorCompanyId: params.get('executorCompanyId') || null,
      selectedElementIds: params.get('elementIds') ? params.get('elementIds').split(',') : [],
      reportData: null,
      defectivenessDetails: [],
      downloadModalOpen: false,
      extraColumns: {},
      showAll: params.get('showAll') === 'true',
      allWeldsPage: 0,
      allWeldsPageSize: 25
    }

    this.handleClearFilters = this.handleClearFilters.bind(this)
    this.handleSelectProjectChange = this.handleSelectProjectChange.bind(this)
    this.handleSelectElementSelectChange = this.handleSelectElementSelectChange.bind(this)
    this.handleWithoutNodesChange = this.handleWithoutNodesChange.bind(this)
    this.handleShowAllChange = this.handleShowAllChange.bind(this)
    this.handleDateFromChange = this.handleDateFromChange.bind(this)
    this.handleDateToChange = this.handleDateToChange.bind(this)
    this.handleDateTypeChange = this.handleDateTypeChange.bind(this)
    this.handleExecutorCompanyChange = this.handleExecutorCompanyChange.bind(this)
    this.updateURL = this.updateURL.bind(this)
    this.fetchReportData = this.fetchReportData.bind(this)
    this.toggleDownloadModal = this.toggleDownloadModal.bind(this)
    this.handleDownload = this.handleDownload.bind(this)
  }

  fetchReportData() {
    const projectId = this.state.project ? this.state.project.id : null
    if (!projectId) return
    const selectedIds = this.state.selectedElementIds
    const project_ids = selectedIds.length > 0 ? selectedIds : null

    this.setState({ data_loading: true })
    
    const basicColumns = ['weld_type', 'thickness_1', 'diameter_1', 'thickness_2', 'diameter_2', 'material_1', 'material_2']
    
    Promise.all([
      this.props.client.query({
        query: ProjectDefectivenessQuery,
        fetchPolicy: 'network-only',
        variables: {
          project_id: projectId,
          project_ids: project_ids,
          with_children: !this.state.withoutNodes,
          date_from: this.state.dateFrom || null,
          date_to: this.state.dateTo || null,
          date_type: this.state.dateType,
          executor_company_id: this.state.executorCompanyId || null
        }
      }),
      this.props.client.query({
        query: ProjectDefectivenessDetailsQuery,
        fetchPolicy: 'network-only',
        variables: {
          project_id: projectId,
          project_ids: project_ids,
          with_children: !this.state.withoutNodes,
          date_from: this.state.dateFrom || null,
          date_to: this.state.dateTo || null,
          selected_columns: basicColumns,
          date_type: this.state.dateType,
          show_all: this.state.showAll,
          executor_company_id: this.state.executorCompanyId || null
        }
      })
    ]).then(([defectivenessResult, detailsResult]) => {
      const project = this.state.project
      let extraCols = {}
      if (project && project.extra_columns) {
        if (typeof project.extra_columns === 'string') {
          try {
            extraCols = JSON.parse(project.extra_columns)
          } catch (e) {
            extraCols = {}
          }
        } else {
          extraCols = project.extra_columns
        }
      }
      
      const details = detailsResult.data.project_defectiveness_details.map(d => JSON.parse(d))
      
      this.setState({
        reportData: defectivenessResult.data.project_defectiveness,
        defectivenessDetails: details,
        extraColumns: extraCols,
        data_loading: false,
        allWeldsPage: 0
      })
    }).catch(() => {
      this.setState({ data_loading: false })
    })
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search)
    const projectId = params.get('project')
    const elementId = params.get('element')
    const withoutNodes = params.get('withoutNodes') === 'true'
    const dateFrom = params.get('dateFrom') || ''
    const dateTo = params.get('dateTo') || ''
    const dateType = params.get('dateType') || 'welding'
    const showAll = params.get('showAll') === 'true'

    this.setState({ withoutNodes, dateFrom, dateTo, dateType, showAll })

    if (projectId) {
      const project = this.props.ProjectsList.find(p => p.id === projectId)
      if (project) {
        this.setState({ data_loading: true })
        this.props.client.query({
          query: ElementsFetchQuery,
          fetchPolicy: 'network-only',
          variables: { parent_id: Number(projectId) }
        }).then(({ data }) => {
          const formattedElements = data.elements.list.map(el => ({
            ...el,
            originalName: el.name,
            name: '\u00A0'.repeat((el.depth - 1) * 2) + el.name
          }))
          this.setState({
            project,
            projectElements: formattedElements,
            data_loading: false
          }, () => {
            if (elementId) {
              const element = data.elements.list.find(e => e.id === elementId)
              if (element) {
                const elementWithOriginalName = { ...element, name: element.name }
                this.setState({ element: elementWithOriginalName }, () => {
                  this.fetchReportData()
                })
              }
            } else {
              this.fetchReportData()
            }
          })
        })
      }
    }
  }

  updateURL() {
    const params = new URLSearchParams()
    if (this.state.project) params.set('project', this.state.project.id)
    if (this.state.element) params.set('element', this.state.element.id)
    if (this.state.withoutNodes) params.set('withoutNodes', 'true')
    if (this.state.showAll) params.set('showAll', 'true')
    if (this.state.selectedElementIds.length > 0) params.set('elementIds', this.state.selectedElementIds.join(','))
    if (this.state.dateFrom) params.set('dateFrom', this.state.dateFrom)
    if (this.state.dateTo) params.set('dateTo', this.state.dateTo)
    if (this.state.dateType) params.set('dateType', this.state.dateType)
    if (this.state.executorCompanyId) params.set('executorCompanyId', this.state.executorCompanyId)
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`)
  }

  static propTypes = {
    ProjectsList: PropTypes.array.isRequired,
    InspectionCategoryTypes: PropTypes.array.isRequired,
    CompaniesList: PropTypes.array.isRequired,
    client: PropTypes.object.isRequired,
    mutate: PropTypes.func.isRequired
  }

  handleClearFilters() {
    this.setState({ project: null, element: null, projectElements: [], filters: {}, withoutNodes: false, dateFrom: '', dateTo: '', dateType: 'welding', executorCompanyId: null, selectedElementIds: [], reportData: null, defectivenessDetails: [] }, () => {
      window.history.replaceState({}, '', window.location.pathname)
    })
  }

  handleWithoutNodesChange(e) {
    this.setState({ withoutNodes: e.target.checked }, () => {
      this.updateURL()
      this.fetchReportData()
    })
  }

  handleShowAllChange(e) {
    this.setState({ showAll: e.target.checked }, () => {
      this.updateURL()
      this.fetchReportData()
    })
  }

  handleDateFromChange(e) {
    this.setState({ dateFrom: e.target.value }, () => {
      this.updateURL()
      this.fetchReportData()
    })
  }

  handleDateToChange(e) {
    this.setState({ dateTo: e.target.value }, () => {
      this.updateURL()
      this.fetchReportData()
    })
  }

  handleDateTypeChange(e) {
    this.setState({ dateType: e.target.value }, () => {
      this.updateURL()
      this.fetchReportData()
    })
  }

  handleExecutorCompanyChange(val) {
    this.setState({ executorCompanyId: val ? val.id : null }, () => {
      this.updateURL()
      this.fetchReportData()
    })
  }

  handleSelectProjectChange(val) {
    if (!val) {
      this.handleClearFilters()
      return
    }

    this.setState({ element: null, reportData: null, defectivenessDetails: [], data_loading: true })
    this.props.client.query({
      query: ElementsFetchQuery,
      fetchPolicy: 'network-only',
      variables: { parent_id: Number(val.id) }
    }).then(({ data }) => {
      const formattedElements = data.elements.list.map(el => ({
        ...el,
        originalName: el.name,
        name: '\u00A0'.repeat((el.depth - 1) * 2) + el.name
      }))
      this.setState({
        project: val,
        projectElements: formattedElements,
        data_loading: false
      }, () => {
        this.updateURL()
        this.fetchReportData()
      })
    })
  }

  handleSelectElementSelectChange(val) {
    const ids = val ? (Array.isArray(val) ? val.map(v => v.id) : [val.id]) : []
    this.setState({ selectedElementIds: ids }, () => {
      this.updateURL()
      this.fetchReportData()
    })
  }

  renderVerticalTable() {
    if (!this.state.reportData) return []
    
    const rows = []
    const { total_complete, total_failed, inspection_categories } = this.state.reportData
    const totalPercent = countPercent(total_complete, total_failed)
    
    rows.push(
      <tr key="welding">
        <td style={{textAlign: 'left'}}><b>ALL INSP.</b></td>
        <td style={{textAlign: 'center'}}>{total_complete}</td>
        <td style={{textAlign: 'center'}}>{total_failed}</td>
        <td style={{textAlign: 'center'}}>{totalPercent > 0 ? <b>{totalPercent}%</b> : `${totalPercent}%`}</td>
      </tr>
    )
    
    inspection_categories.forEach(category => {
      const percent = category.failed_percentage
      rows.push(
        <tr key={category.inspection_category_type_id}>
          <td style={{textAlign: 'left'}}><b>{category.inspection_category_type_name}</b></td>
          <td style={{textAlign: 'center'}}>{category.total_complete}</td>
          <td style={{textAlign: 'center'}}>{category.total_failed}</td>
          <td style={{textAlign: 'center'}}>{percent > 0 ? <b>{percent}%</b> : `${percent}%`}</td>
        </tr>
      )
    })
    
    return rows
  }

  toggleDownloadModal() {
    this.setState(prev => ({ downloadModalOpen: !prev.downloadModalOpen }))
  }

  handleDownload(format, columns, extraColumns) {
    this.createReportJob(format, columns || [], extraColumns || [])
  }

  createReportJob(format, columns = [], extraColumns = []) {
    const projectId = this.state.element ? this.state.element.id : (this.state.project ? this.state.project.id : null)
    if (!projectId) return

    this.props.mutate({
      variables: {
        type: 'WlWelds::Jobs::ProjectDefectivenessReport',
        project_id: parseInt(projectId, 10),
        args: JSON.stringify({
          format: format,
          with_children: !this.state.withoutNodes,
          date_from: this.state.dateFrom || null,
          date_to: this.state.dateTo || null,
          date_type: this.state.dateType,
          columns: columns,
          extra_columns: extraColumns,
          show_all: this.state.showAll,
          executor_company_id: this.state.executorCompanyId ? parseInt(this.state.executorCompanyId, 10) : null,
          project_ids: this.state.selectedElementIds.length > 0 ? this.state.selectedElementIds.map(id => parseInt(id, 10)) : null
        })
      }
    }).then((response) => {
      console.log('Job created:', response)
      this.props.client.query({
        query: GET_JOBS,
        fetchPolicy: 'network-only'
      }).then(({ data }) => {
        const notifyCount = data.user_jobs ? data.user_jobs.filter(job => job.notify).length : 0
        const event = new CustomEvent('changeNotifyCountInApp', { detail: { notifyCount } })
        window.dispatchEvent(event)
      })
    }).catch((error) => {
      console.error('Error creating job:', error)
      alert('Error creating report job. Check console for details.')
    })
  }

  render() {
    return (
      <Card>
        <CardHeader>
          <AvForm id="project-defectiveness-form" className="FormClassLabel">
            <Row>
              <Col xs="12" sm="3">
                <CreatableSelect
                  label="Select project"
                  id="project-defectiveness-select"
                  valueKey="id"
                  options={this.props.ProjectsList}
                  value={this.state.project}
                  multi={false}
                  creatable={false}
                  valueChangeFunction={this.handleSelectProjectChange}
                />
                <CreatableSelect
                  label="Elements (multi)"
                  id="element-defectiveness-select"
                  options={this.state.projectElements}
                  valueKey="id"
                  value={this.state.selectedElementIds}
                  multi={true}
                  creatable={false}
                  valueChangeFunction={this.handleSelectElementSelectChange}
                />
              </Col>
              <Col xs="12" sm="2">
                <Label>Without nodes</Label>
                <div style={{ display: 'flex', alignItems: 'center', height: '38px', marginTop: '-8px' }}>
                  <Input
                    type="checkbox"
                    checked={this.state.withoutNodes}
                    onChange={this.handleWithoutNodesChange}
                    style={{ width: 'auto', position: 'static', marginLeft: 0 }}
                  />
                </div>
                <Label>Show all welds</Label>
                <div style={{ display: 'flex', alignItems: 'center', height: '38px', marginTop: '-8px' }}>
                  <Input
                    type="checkbox"
                    checked={this.state.showAll}
                    onChange={this.handleShowAllChange}
                    style={{ width: 'auto', position: 'static', marginLeft: 0 }}
                  />
                </div>
              </Col>
              <Col xs="12" sm="2">
                <FormGroup>
                  <Label for="date-type">Date type</Label>
                  <Input
                    type="select"
                    id="date-type"
                    value={this.state.dateType}
                    onChange={this.handleDateTypeChange}
                  >
                    <option value="welding">Welding</option>
                    <option value="inspection">Inspection</option>
                    <option value="welding_log_create">Welding Log Create</option>
                    <option value="inspection_log_create">Inspection Log Create</option>
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label for="executor-company">Executor company</Label>
                  <Input
                    type="select"
                    id="executor-company"
                    value={this.state.executorCompanyId || ''}
                    onChange={e => this.handleExecutorCompanyChange(e.target.value ? { id: e.target.value } : null)}
                  >
                    <option value="">All companies</option>
                    {this.props.CompaniesList.map(c => (
                      <option key={c.id} value={c.id}>{c.name}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col xs="12" sm="2">
                <FormGroup>
                  <Label for="date-from">Date from</Label>
                  <Input
                    type="date"
                    id="date-from"
                    value={this.state.dateFrom}
                    onChange={this.handleDateFromChange}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="date-to">Date to</Label>
                  <Input
                    type="date"
                    id="date-to"
                    value={this.state.dateTo}
                    onChange={this.handleDateToChange}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="3">
                <Label>&nbsp;</Label>
                <div>
                  <Button color="secondary" onClick={this.handleClearFilters}>Clear filters</Button>
                </div>
              </Col>
            </Row>
            {this.state.reportData && (
              <Row style={{ marginTop: '10px' }}>
                <Col xs="12" style={{ textAlign: 'right' }}>
                  <Button color="primary" onClick={this.toggleDownloadModal}>
                    <i className="fa fa-download" /> Download
                  </Button>
                </Col>
              </Row>
            )}
          </AvForm>
        </CardHeader>
        <BlockWithLoader loading={this.state.data_loading} renderChildren={true}>
          <CardBody>
            {!this.state.project && !this.state.element ? (
              <div style={{textAlign: 'center', padding: '40px', fontSize: '18px', color: '#666'}}>
                Please select a project or element to view the report
              </div>
            ) : this.state.reportData ? (
              <div>
                <Table bordered striped responsive id="project-defectiveness-table">
                  <thead>
                    <tr>
                      <th style={{width: '200px', textAlign: 'center'}}>
                        {this.state.element ? this.state.element.name : this.state.project.name}
                        <br/>
                        (length {this.state.reportData.total_length} mm)
                      </th>
                      <th style={{textAlign: 'center'}}>Complete [mm]</th>
                      <th style={{textAlign: 'center'}}>Failed [mm]</th>
                      <th style={{textAlign: 'center'}}>Failed [%]</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderVerticalTable()}
                  </tbody>
                </Table>
                
                {this.state.defectivenessDetails && this.state.defectivenessDetails.length > 0 && (() => {
                  const defective = this.state.defectivenessDetails.filter(d => d.defective)
                  const nonDefective = this.state.defectivenessDetails.filter(d => !d.defective)
                  const PAGE_SIZE = this.state.allWeldsPageSize
                  const totalPages = Math.ceil(nonDefective.length / PAGE_SIZE)
                  const pagedNonDefective = nonDefective.slice(this.state.allWeldsPage * PAGE_SIZE, (this.state.allWeldsPage + 1) * PAGE_SIZE)
                  const renderTable = (rows) => (
                    <Table bordered striped responsive size="sm" style={{fontSize: '12px'}}>
                      <thead>
                        <tr>
                          <th>Element</th>
                          <th>Weld no</th>
                          <th>Weld length</th>
                          <th>Weld type</th>
                          <th>Thickness 1</th>
                          <th>Diameter 1</th>
                          <th>Thickness 2</th>
                          <th>Diameter 2</th>
                          <th>Material 1</th>
                          <th>Material 2</th>
                          <th>WPS</th>
                          <th>Welder</th>
                          <th>Welding datetime</th>
                          <th>Welding Log Create</th>
                          <th>Inspection type</th>
                          <th>Inspection date</th>
                          <th>Inspection Log Create</th>
                          <th>Percent</th>
                          <th>Inspected length</th>
                          <th>Defect length</th>
                          <th>Defect type (ISO-6520-1)</th>
                          <th>Report no</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((detail, idx) => (
                          <tr key={idx}>
                            <td>{detail.element}</td>
                            <td>{detail.weld_no}</td>
                            <td>{detail.weld_length}</td>
                            <td>{detail.weld_type}</td>
                            <td>{detail.thickness_1}</td>
                            <td>{detail.diameter_1}</td>
                            <td>{detail.thickness_2}</td>
                            <td>{detail.diameter_2}</td>
                            <td>{detail.material_1}</td>
                            <td>{detail.material_2}</td>
                            <td>{detail.wps}</td>
                            <td>{detail.welder_no}</td>
                            <td>{detail.welding_date}</td>
                            <td>{detail.welding_log_create_date}</td>
                            <td>{detail.inspection_type}</td>
                            <td>{detail.inspection_date}</td>
                            <td>{detail.inspection_log_create_date}</td>
                            <td>{detail.category_range}</td>
                            <td>{detail.inspected_length}</td>
                            <td>{detail.defect_length}</td>
                            <td>{detail.defect_type}</td>
                            <td>{detail.report_no}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )
                  return (
                    <div>
                      {defective.length > 0 && (
                        <div style={{marginTop: '30px'}}>
                          <h5>Defective Welds Details</h5>
                          {renderTable(defective)}
                        </div>
                      )}
                      {this.state.showAll && nonDefective.length > 0 && (
                        <div style={{marginTop: '30px'}}>
                          <h5>All Welds Details</h5>
                          {renderTable(pagedNonDefective)}
                          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginTop: '8px'}}>
                            <Button size="sm" disabled={this.state.allWeldsPage === 0} onClick={() => this.setState(p => ({ allWeldsPage: p.allWeldsPage - 1 }))}>&laquo;</Button>
                            <span>Page {this.state.allWeldsPage + 1} / {totalPages}</span>
                            <Button size="sm" disabled={this.state.allWeldsPage >= totalPages - 1} onClick={() => this.setState(p => ({ allWeldsPage: p.allWeldsPage + 1 }))}>&raquo;</Button>
                            <Input type="select" bsSize="sm" style={{width: 'auto'}} value={this.state.allWeldsPageSize} onChange={e => this.setState({ allWeldsPageSize: Number(e.target.value), allWeldsPage: 0 })}>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={100}>100</option>
                            </Input>
                            <span style={{color: '#666'}}>/ page</span>
                          </div>
                        </div>
                      )}
                    </div>
                  )
                })()}
              </div>
            ) : null}
          </CardBody>
        </BlockWithLoader>
        <DownloadReportModal
          isOpen={this.state.downloadModalOpen}
          toggle={this.toggleDownloadModal}
          onDownload={this.handleDownload}
          extraColumns={this.state.extraColumns}
        />
      </Card>
    )
  }
}

export default graphql(CreateProjectDefectivenessReportJob)(withApollo(ProjectDefectiveness))



// WEBPACK FOOTER //
// ./src/components/Report/ProjectDefectiveness.js